export default __webpack_public_path__ + "static/media/apply-leave-enabled.428cba20.svg";